// SpecialBarChartForKPI05.js

import React from "react";
import ReactApexChart from "react-apexcharts";

const SpecialBarChartForKPI05 = ({ kpi }) => {
  const series = [
    {
      name: kpi.kpi_code,
      data: [
        kpi.avg_target_performance,
        kpi.avg_actual_performance,
        kpi.avg_internal_benchmark,
        kpi.avg_external_benchmark,
        kpi.avg_new_target_performance,
      ],
    },
  ];

  const categories = [
    "Avg Target",
    "Avg Actual",
    "Internal Benchmark",
    "External Benchmark",
    "New Target",
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "7%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}`,
      style: {
        fontSize: "12px",
      },
    },
    xaxis: {
      categories: categories,
      title: {
        text: "المحاور",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}`,
      },
      title: {
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
    },
    colors: ["#282562"],
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3">{kpi.kpi_code}</h5>
      <ReactApexChart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default SpecialBarChartForKPI05;
